import { ClipboardCheck, MonitorCog, Settings, Wrench, Paintbrush, Users } from "lucide-react";
import { AnimatedSection, StaggerContainer, StaggerItem } from "@/components/AnimatedSection";

const capabilities = [
  { icon: ClipboardCheck, title: "MOT Testing", desc: "Authorised government testing station — Classes 1–5 and 7." },
  { icon: MonitorCog, title: "Diagnostic Equipment", desc: "Professional-grade OBD-II and professional-grade scanners." },
  { icon: Settings, title: "Full Servicing", desc: "Interim, full and major services with OE-quality parts." },
  { icon: Wrench, title: "Mechanical Repairs", desc: "Brakes, clutch, suspension, gearbox, steering, exhaust." },
  { icon: Paintbrush, title: "Bodywork & Paint", desc: "Dent repair, paint correction, bumper work, colour matching." },
  { icon: Users, title: "Experienced Team", desc: "Skilled technicians who take pride in doing the job properly." },
];

export function WorkshopCapabilities() {
  return (
    <AnimatedSection>
      <section className="py-16 md:py-20">
        <div className="mx-auto max-w-6xl px-4 md:px-6">
          <div className="text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-foreground">Workshop Capabilities</h2>
            <p className="mt-2 text-muted-foreground">Everything under one roof — properly equipped and professionally run.</p>
          </div>
          <StaggerContainer className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {capabilities.map((c) => (
              <StaggerItem key={c.title}>
                <div className="flex gap-4 p-5 rounded-xl border border-border bg-card hover:border-primary/30 hover:shadow-lg hover:shadow-primary/5 transition-all duration-300">
                  <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-primary/8 shrink-0">
                    <c.icon className="h-5 w-5 text-primary" />
                  </div>
                  <div>
                    <h3 className="text-[15px] font-bold text-foreground">{c.title}</h3>
                    <p className="mt-1 text-sm text-muted-foreground leading-relaxed">{c.desc}</p>
                  </div>
                </div>
              </StaggerItem>
            ))}
          </StaggerContainer>
        </div>
      </section>
    </AnimatedSection>
  );
}
